/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import currency from "currency.js";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { COLORS } from "../../../constants/design/colors";
import { COMPONENTS } from "../../../constants/design/spacing";
import { formatOrderbookSize } from "../../../utils/format";
import { LabelText, SublabelText } from "../../shared/Label/style";
import { RowWithSizeIndicator } from "../../shared/Table/style";
import {
  DetailBlock,
  DetailHeader,
  IVValue,
  PositionDetails,
  TradeCol,
} from "./style";
import { ISpreadProps, headerFlex, maxCumulativeFillPercent } from "./types";

export function OrderbookRow({
  price,
  iv,
  size,
  cumulativeSize,
  sizeIsUSD,

  sizeDecimals,
  priceDecimals,
  accountSize,
  totalSize,
  color,
  textColor,
  type,
  index,
  rowHeight,
}: ISpreadProps) {
  const { t } = useTranslation("app", {
    keyPrefix: "TicketDetails.TradeOrderbook",
  });
  const [isHovering, setHovering] = useState<boolean>(false);

  const cumulativeFill =
    totalSize && size
      ? (Number(cumulativeSize) / totalSize) * maxCumulativeFillPercent
      : 0;
  const accountSizeRelativeToSize =
    accountSize && size ? (accountSize / Number(size)) * cumulativeFill : 0;

  return (
    <>
      {isHovering && accountSize > 0 && (
        <PositionDetails
          indexFromLastRow={index}
          positionType={type}
          onMouseEnter={() => setHovering(true)}
          onMouseLeave={() => setHovering(false)}
        >
          <DetailHeader>
            <LabelText>
              {type === "bid" ? t("your_bid") : t("your_ask")}
            </LabelText>
          </DetailHeader>
          <DetailBlock>
            <SublabelText>{t("contracts_offered")}</SublabelText>
            <LabelText>
              {currency(accountSize, { precision: sizeDecimals }).format({
                symbol: "",
              })}
            </LabelText>
          </DetailBlock>
        </PositionDetails>
      )}
      <RowWithSizeIndicator
        highlightOnHover
        needsAnimation
        fillColor={color}
        fillPercent={Number(price) ? cumulativeFill * 100 : 0}
        fillTo={"left"}
        onRowHover={(e) => setHovering(e)}
        style={{
          zIndex: 1,
          backgroundColor:
            // eslint-disable-next-line no-nested-ternary
            (Number(price) && accountSize) > 0
              ? type === "ask"
                ? COLORS.down.six
                : COLORS.up.six
              : undefined,
          height: rowHeight || COMPONENTS.tableRowSmall,
        }}
      >
        {accountSize > 0 && (
          <RowWithSizeIndicator
            fillColor={textColor}
            fillPercent={accountSizeRelativeToSize * 100}
            fillTo={"left"}
            onRowHover={(e) => setHovering(e)}
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              width: "100%",
              opacity: 0.4,
              zIndex: -1,
            }}
          />
        )}
        {Number(price) === 0 ? (
          <TradeCol style={{ flex: headerFlex["Price / IV"] }} />
        ) : (
          <TradeCol
            style={{ color: textColor, flex: headerFlex["Price / IV"] }}
          >
            <span>
              {currency(price, { precision: priceDecimals }).format()}
            </span>
            {iv !== undefined && (
              <IVValue>{(Number(iv || 0) * 100).toFixed(2)}%</IVValue>
            )}
          </TradeCol>
        )}
        <TradeCol style={{ flex: headerFlex.Size }}>
          {Number(size) !== 0
            ? formatOrderbookSize(size, sizeIsUSD ? 2 : sizeDecimals)
            : ""}
        </TradeCol>
        <TradeCol style={{ flex: headerFlex.Cumulative }}>
          {Number(size) !== 0
            ? formatOrderbookSize(cumulativeSize, sizeIsUSD ? 2 : sizeDecimals)
            : ""}</TradeCol>
      </RowWithSizeIndicator>
    </>
  );
}
